webpackJsonp([169310805621404],{

/***/ 139:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMXB4IiB2aWV3Qm94PSIwIDAgMjEgMjEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjEgKDUxMTQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Hcm91cDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSJEZXNrdG9wLUhELUNvcHktMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0OS4wMDAwMDAsIC04NjQuMDAwMDAwKSIgc3Ryb2tlPSIjOTc5Nzk3Ij4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDkuMDAwMDAwLCA4NjQuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlBhdGgtMiIgcG9pbnRzPSIwIDEwLjAxMjUgMjAuMDIwMDAwNSAxMC4wMTI1IDEwLjAwOTk5MjQgMCI+PC9wb2x5bGluZT4KICAgICAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iUGF0aC0yLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwLjAxMDAwMCwgMTUuMDA2MjUwKSBzY2FsZSgxLCAtMSkgdHJhbnNsYXRlKC0xMC4wMTAwMDAsIC0xNS4wMDYyNTApICIgcG9pbnRzPSIwIDIwLjAxMjUgMjAuMDIwMDAwNSAyMC4wMTI1IDEwLjAwOTk5MjQgMTAiPjwvcG9seWxpbmU+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bg.150fa882.png";

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.JournalQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(39);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(81);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _footer = __webpack_require__(27);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _arrow = __webpack_require__(139);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _bg = __webpack_require__(140);
	
	var _bg2 = _interopRequireDefault(_bg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Journals = function (_React$Component) {
	  _inherits(Journals, _React$Component);
	
	  function Journals() {
	    _classCallCheck(this, Journals);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Journals.prototype.render = function render() {
	    var siteTitle = (0, _get2.default)(this, 'props.data.site.siteMetadata.title');
	    var journals = (0, _get2.default)(this, 'props.data.allMarkdownRemark.edges');
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: (0, _get2.default)(this, 'props.data.site.siteMetadata.title') }),
	      _react2.default.createElement(
	        'div',
	        { className: 'root-width rw-pad' },
	        _react2.default.createElement(
	          'div',
	          { style: { display: "flex", marginTop: "1.5em" } },
	          _react2.default.createElement(
	            'div',
	            { className: 'journal-side', style: { display: "none" } },
	            _react2.default.createElement(
	              'div',
	              { className: 'journal-sidebar' },
	              'Sidebar'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'journal-main' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Journal'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'journal-holder' },
	              journals.filter(function (d) {
	                return d.type == "journal";
	              }).length > 0 ? journals.filter(function (d) {
	                return d.type == "journal";
	              }).map(function (journal) {
	                if (journal.node.path !== '/404/') {
	                  var title = (0, _get2.default)(journal, 'node.frontmatter.title') || journal.node.path;
	                  var thumbImage = journal.node.frontmatter.thumb.childImageSharp.resize.src;
	                  var color = journal.node.frontmatter.color;
	                  var tags = journal.node.frontmatter.tags;
	                  var active = journal.node.frontmatter.active;
	                  var type = journal.node.frontmatter.type;
	                  return _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: journal.node.frontmatter.path, key: journal.node.frontmatter.path },
	                    title
	                  );
	                }
	              }) : _react2.default.createElement(
	                'div',
	                { className: 'no-data' },
	                'There are no posts available. Please check back later.'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_footer2.default, null)
	    );
	  };
	
	  return Journals;
	}(_react2.default.Component);
	
	Journals.propTypes = {
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = Journals;
	var JournalQuery = exports.JournalQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-journal-js-eb9807b7bd1df55d5bcb.js